'use strict';

var i18n = require('i18next');
var EditTimezone = require('actions/router/timezone/EditTimezone');
var FormView = require('actions/router/timezone/FormView');
var StaticView = require('actions/router/timezone/StaticView');

/**
 * Action configuration for the Timezone action component.
 */
module.exports = {
  title: i18n.t('actionTimezone.title'),
  Model: EditTimezone,
  FormView: FormView,
  TextView: StaticView,
};
